import { EntityApi } from "../../services/ApiPlatform";

export abstract class CompanyDocumentApi extends EntityApi {
    protected static GET_COLLECTION = "/api/company-documents";

    protected static POST_COLLECTION = "/api/company-documents";

    protected static GET_ITEM = "/api/company-documents/{id}";

    protected static PATCH_ITEM = "/api/company-documents/{id}";

    protected static DELETE_ITEM = "/api/company-documents/{id}";
}
